import { request } from './client';

export type LedgerType = 'topup' | 'charge' | 'refund' | 'trial' | 'adjust';

export interface LedgerEntry {
  id: string;
  type: LedgerType;
  amount_ngonka: string;
  balance_after: string;
  req_id: string | null;
  model: string | null;
  native_amount: string | null;
  native_unit: string | null;
  markup_pct: string | null;
  gnk_usd_rate: string | null;
  prompt_tokens: number | null;
  completion_tokens: number | null;
  total_tokens: number | null;
  overdraft: boolean;
  topup_source: string | null;
  note: string | null;
  created_at: string;
}

export interface ListLedgerResponse {
  entries: LedgerEntry[];
  next_cursor: string | null;
}

export interface ListLedgerParams {
  limit?: number;
  cursor?: string;
  types?: LedgerType[];
}

export const ledgerApi = {
  list: (params: ListLedgerParams = {}) => {
    const q = new URLSearchParams();
    if (params.limit) q.set('limit', String(params.limit));
    if (params.cursor) q.set('cursor', params.cursor);
    if (params.types && params.types.length > 0) q.set('types', params.types.join(','));
    const qs = q.toString();
    return request<ListLedgerResponse>(`/api/ledger${qs ? `?${qs}` : ''}`);
  },
};
